export enum SubscriptionInterval {
    MONTH = 'month',
    YEAR = 'year'
}
